import * as types from './actionTypes';

export function authenticatedSuccess(authenticationInfo) {
    return {
        type: types.AUTHENTICATION_SUCCESS,
        payload: authenticationInfo
    };
}

export function userInfoReceived(userInfo) {

    return {
        type: types.AUTHENTICATION_USERINFO_RETRIEVED,
        payload: userInfo
    };
}

export function setAuthenticationError(message) {
    return {
        type: types.AUTHENTICATION_ERRORMESSAGE,
        payload: message
    };
}

export function setUsername(username) {
    return {
        type: types.AUTHENTICATION_SET_USERNAME,
        payload: username
    };
}

export function setUserPassword(password) {
    return {
        type: types.AUTHENTICATION_SET_PASSWORD,
        payload: password
    };
}

export function loginSuccess() {
    return {
        type: types.AUTHENTICATION_LOGIN_COMPLETED_SUCCESS,
        payload: null
    };
}

export function logout() {
    return {
        type: types.AUTHENTICATION_LOGOUT
    };
}
